// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"89":"dafeb06ebacca7b7","698":"3e44c2c5d88c4538"}[chunkId] + ".css";
};